export default __webpack_public_path__ + "static/sublimation2-ba15136ddaeb15cbea9eaf724bf7551f.jpg";